import {appFetch, AppFetchResponse} from "../utils/appFetch";

const getTotalRecovered = (days: number, selectedDomain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `statistics/total-recovered-revenue/${days}?domain=${selectedDomain}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}

export default getTotalRecovered;